import { Clock, Loader2, Route } from "lucide-react";
import type { RouteEstimate } from "@/services/googleDirectionsService";

interface RouteEstimatePreviewProps {
  estimate?: RouteEstimate | null;
  isLoading?: boolean;
  isError?: boolean;
  compact?: boolean;
}

export function RouteEstimatePreview({
  estimate,
  isLoading = false,
  isError = false,
  compact = false,
}: RouteEstimatePreviewProps) {
  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin text-primary" />
        Calculating distance & travel time...
      </div>
    );
  }

  if (isError) {
    return (
      <p className="text-sm text-destructive">
        Unable to calculate distance and travel time.
      </p>
    );
  }

  if (!estimate) return null;

  return (
    <div
      className={
        compact
          ? "flex flex-wrap gap-2"
          : "grid grid-cols-1 gap-2 sm:grid-cols-2"
      }
    >
      <div className="inline-flex items-center gap-2 rounded-lg bg-primary/5 px-3 py-2 text-sm">
        <Route className="h-4 w-4 shrink-0 text-primary" />
        <span className="text-muted-foreground">Distance:</span>
        <span className="font-semibold text-foreground">{estimate.distanceText}</span>
      </div>
      <div className="inline-flex items-center gap-2 rounded-lg bg-primary/5 px-3 py-2 text-sm">
        <Clock className="h-4 w-4 shrink-0 text-primary" />
        <span className="text-muted-foreground">Travel time:</span>
        <span className="font-semibold text-foreground">{estimate.durationText}</span>
      </div>
    </div>
  );
}
